/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  clusterId: ZodTypes.Id,
});

export const GetClusterPgHba = {
  id: 'cluster-pg-hba.get',
  tag: 'Cluster',
  summary: 'Get cluster pg-hba',
  description: 'Retrieve the pg-hba information of a cluster',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.clusterId}/pg-hba`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(
            z.strictObject({
              type: z.enum(['host', 'hostssl', 'hostnossl']),
              database: z.array(z.string().min(1)).or(z.string().min(1)),
              user: z.array(z.string().min(1)).or(z.string().min(1)),
              address: z.string().min(1),
              authenticationMethod: z.enum(['scram-sha-256', 'md5', 'trust']),
            }),
          ),
        },
      },
    },
  },
} as const satisfies Endpoint;
